import React from 'react'
import SliderImage from '../assets/images/banner.png'

const SliderComponent: React.FC = () => {
	return (
		<section className='bg-sky-50 shadow-lg animate-slide-up md:col-span-3'>
			<img src={SliderImage} alt='Slider' className='w-full h-auto' />
		</section>
	)
}

export default SliderComponent
